import { useSearchParams } from "react-router-dom"
import ChartToolbar from "./usage-chart-toolbar"
import UsageChart from "./usage-chart"
import UsageChartKpi from "./usage-chart-kpi"
import { usageChartStore } from "../usage-chart-store"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { getThisMonthWaterBill } from "@/routes/apt/[apt_code]/water-bill-util"
import { langStore } from "@/stores/lang-store"
import useIsMobile from "@/hooks/use-is-mobile"
import { RESOURCES } from "@/constants/resource-const"
import { usageMetrics } from "../usage-const"
import Wrapper from "@/components/wrapper"

const UsageChartView = ({ className }) => {
  const { lang } = langStore()
  const isMobile = useIsMobile()
  const [searchParams] = useSearchParams()
  const resource = searchParams.get("resource") ?? "water"

  const { series, xLabels, leakSum, usageSum, leakRate } = usageChartStore()

  const { region_key } = aptSearchStore((s) => s.pickApt)

  const usageBill =
    resource !== "water" ? 0 : usageSum === 0 ? 0 : getThisMonthWaterBill(region_key, usageSum)

  const leakBill = resource !== "water" ? 0 : getThisMonthWaterBill(region_key, leakSum, true)

  const currentResourceLabel =
    RESOURCES.find(({ id }) => id === resource)?.label?.[lang] || usageMetrics.usage[lang]
  const currentResourceBillTitle =
    lang === "ko" ? `${currentResourceLabel} 요금` : `${currentResourceLabel} Bill`

  const kpiList = [
    {
      title: usageMetrics.usage[lang],
      value: `${usageSum.toFixed(2)} m³`,
      accent: "text-blue-600"
    },
    {
      title: usageMetrics.leakAmount[lang],
      value: `${leakSum.toFixed(2)} m³`,
      accent: leakSum ? "text-orange-500" : "text-gray-500"
    },
    {
      title: usageMetrics.leakRate[lang],
      value: `${leakRate.toFixed(2)} %`,
      accent: leakRate ? "text-red-500" : "text-gray-500"
    },
    {
      title: currentResourceBillTitle,
      value: `${usageBill.toLocaleString()} ${usageMetrics.currency[lang]}`,
      accent: "text-blue-600"
    },
    {
      title: usageMetrics.leakBill[lang],
      value: `${leakBill.toLocaleString()} ${usageMetrics.currency[lang]}`,
      accent: leakSum ? "text-orange-500" : "text-gray-500"
    },
    {
      title: usageMetrics.billRatio[lang],
      value: `${(usageBill === 0 ? 0 : (leakBill / usageBill) * 100).toFixed(1)} %`,
      accent: leakRate ? "text-red-500" : "text-gray-500"
    }
  ]

  if (isMobile) return null

  return (
    <Wrapper.shadow className={className}>
      <ChartToolbar resource={resource} />

      <div
        className="
          min-h-75 min-w-0 flex-1
          2xl:py-10 3xl:py-12
        "
      >
        <UsageChart series={series} xLabels={xLabels} />
      </div>

      <UsageChartKpi items={kpiList} />
    </Wrapper.shadow>
  )
}

export default UsageChartView
